export default "__VITE_ASSET__e1b70f28__"